/* eslint-disable import/extensions */

// Services Img Imports
import Web from "../assets/images/Services/Web.png";
import Mobile from "../assets/images/Services/Mobile.png";
import UIUX from "../assets/images/Services/Design.png";

// Portfolio Img Imports
// import Recruiting from '../assets/images/Portfolio/Recruiting.png';
import NstSSO from "../assets/images/Portfolio/logoSSO.jpg";
import BDBinhPhuoc from "../assets/images/Portfolio/bpclub.png";
import BDLonngAn from "../assets/images/Portfolio/nhomld.png";
import VOExim from "../assets/images/Portfolio/exim.png";
import VOHeiniken from "../assets/images/Portfolio/heini.png";
import CmsIot from "../assets/images/Portfolio/sgiot.png";
import CmsIot1 from "../assets/images/Portfolio/sgiot1.png";
import KyHop from "../assets/images/Portfolio/logo-ky-hop.png";
import logoSGD from "../assets/images/Portfolio/logoSGD.png";

// Advantages
import Communicative from "../assets/images/Advantages/Communicative.png";
import Collaborative from "../assets/images/Advantages/Collaborative.png";
import Management from "../assets/images/Advantages/Management.png";
import Favorite from "../assets/images/Advantages/Favorite.png";

// ImgCompany
import ViettelComp from "../assets/images/Testimonials/ViettelComp.jpg";
import EximbankComp from "../assets/images/Testimonials/EximbankComp.png";
import HeinekenComp from "../assets/images/Testimonials/HeinekenComp.png";
import ViettelUser from "../assets/images/Testimonials/ViettelUser.png";
import EximbankUser from "../assets/images/Testimonials/EximbankUser.png";
import HeinekenUser from "../assets/images/Testimonials/HeinekenUser.png";

// TeamMembers
import CEO from "../assets/images/TeamMembers/CEO.jpg";
import HRD from "../assets/images/TeamMembers/HRD.jpg";
import Finance from "../assets/images/TeamMembers/Finance.jpg";
import ProjectManager from "../assets/images/TeamMembers/Project-manager.jpg";
import Frontend1 from "../assets/images/TeamMembers/Frontend1.jpg";
import Frontend2 from "../assets/images/TeamMembers/Frontend2.jpg";
import Backend1 from "../assets/images/TeamMembers/Backend1.jpg";
import Backend2 from "../assets/images/TeamMembers/Backend2.jpg";
import Mobile1 from "../assets/images/TeamMembers/Mobile1.jpg";
import Mobile2 from "../assets/images/TeamMembers/Mobile2.jpg";
import UIUX1 from "../assets/images/TeamMembers/UIUX1.jpg";
import UIUX2 from "../assets/images/TeamMembers/UIUX2.jpg";

// Partner
import ViettelCompPN from "../assets/images/Partner/ViettelComp.png";
// import MobifoneComp from '../assets/images/Partner/MobifoneComp.png';
// import NatureFoodsComp from '../assets/images/Partner/NatureFoodsComp.png';
// import MatBaoComp from '../assets/images/Partner/MatBaoComp.png';
// import ABBANKComp from '../assets/images/Partner/ABBANKComp.png';
// import EmivestComp from '../assets/images/Partner/EmivestComp.png';
// import MekopharComp from '../assets/images/Partner/MekopharComp.png';
// import FPTComp from '../assets/images/Partner/FPTComp.png';
// import BaoAnComp from '../assets/images/Partner/BaoAnComp.png';

export const Services = [
  {
    title: "Web Development",
    imageUrl: Web,
    animation: "left",
    description:
      "Chúng tôi cung cấp dịch vụ phát triển website chuyên nghiệp, tối ưu hiệu suất và thân thiện với người dùng. Từ thiết kế giao diện đến lập trình backend, chúng tôi đảm bảo tạo ra các trang web hiện đại, bảo mật và dễ dàng mở rộng.",
  },
  {
    title: "Mobile Development",
    imageUrl: Mobile,
    animation: "up",
    description:
      "Phát triển ứng dụng di động trên cả nền tảng iOS và Android, đáp ứng nhu cầu đa dạng của doanh nghiệp. Chúng tôi xây dựng ứng dụng có hiệu suất cao, giao diện trực quan, giúp doanh nghiệp tiếp cận người dùng mọi lúc, mọi nơi.",
  },
  {
    title: "UI/UX Design",
    imageUrl: UIUX,
    animation: "right",
    description:
      "Thiết kế giao diện và trải nghiệm người dùng theo xu hướng hiện đại, tập trung vào sự tiện lợi và tối ưu hóa tương tác. Chúng tôi nghiên cứu hành vi người dùng để mang lại những sản phẩm trực quan, dễ sử dụng và gia tăng trải nghiệm khách hàng.",
  },
];

export const Partners = [
  {
    title: "Viettel Business Solutions",
    imageUrl: ViettelCompPN,
  },
];

export const Customers = [
  {
    title: "Viettel Business Solutions",
    imageUrl: ViettelCompPN,
  },
  // {
  //   title: 'Mobifone',
  //   imageUrl: MobifoneComp,
  // },
  // {
  //   title: 'Nature Foods Co. Ltd',
  //   imageUrl: NatureFoodsComp,
  // },
  // {
  //   title: 'Mat Bao',
  //   imageUrl: MatBaoComp,
  // },
  // {
  //   title: 'ABBANK',
  //   imageUrl: ABBANKComp,
  // },
  // {
  //   title: 'Emivest GMP WHO',
  //   imageUrl: EmivestComp,
  // },
  // {
  //   title: 'Mekophar',
  //   imageUrl: MekopharComp,
  // },
  // {
  //   title: 'FPT',
  //   imageUrl: FPTComp,
  // },
  // {
  //   title: 'Bảo An',
  //   imageUrl: BaoAnComp,
  // },
];

export const Portfolios = [
  {
    id: "nst-sso",
    title: "Hệ thống xác thực tập trung (NST-SSO)",
    imageUrl: NstSSO,
    type: "Website / Mobile Apps",
    responsibility: ["Mobile Development", "UI/UX Design"],
    credit: "https://dribbble.com/shots/15223131-Freelance-Mobile-App-Concept",
  },
  {
    id: "vo-eximbank",
    title: "VOffice Eximbank",
    imageUrl: VOExim,
    type: "Website / Mobile Apps",
    responsibility: ["Web Development", "UI/UX Design"],
    credit: "https://dribbble.com/shots/15176338-Aura-Website-Main-Page",
  },
  {
    id: "vo-nhom-ld",
    title: "VOffice Nhôm LĐ",
    imageUrl: BDLonngAn,
    type: "Website / Mobile Apps",
    responsibility: ["Web Development", "UI/UX Design"],
    credit:
      "https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App",
  },
  {
    id: "vo-heiniken",
    title: "VOffice Heiniken",
    imageUrl: VOHeiniken,
    type: "Website / Mobile Apps",
    responsibility: ["Mobile Development", "UI/UX Design"],
    credit: "https://dribbble.com/shots/15223131-Freelance-Mobile-App-Concept",
  },
  {
    id: "bd-binh-phuoc",
    title: "Bóng Đá BP",
    imageUrl: BDBinhPhuoc,
    type: "Website / Mobile Apps",
    responsibility: ["Web Development", "UI/UX Design"],
    credit: "https://dribbble.com/shots/15176338-Aura-Website-Main-Page",
  },
  {
    id: "cms-iot",
    title: "CMS IOT",
    imageUrl: CmsIot,
    imageUrlDetail: CmsIot1,
    type: "Website / Mobile Apps",
    responsibility: ["Web Development", "UI/UX Design"],
    credit:
      "https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App",
  },
  {
    id: "phan-mem-quan-ly-dieu-hanh-dai-hoi-dang",
    title: "Phần mềm quản lý điều hành Đại hội Đảng",
    imageUrl: KyHop,
    imageUrlDetail: KyHop,
    type: "Website / Mobile Apps",
    responsibility: ["Web Development", "UI/UX Design"],
    credit:
      "https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App",
  },
  {
    id: "he-thong-phan-mem-san-giao-dich-cong-nghe",
    title: "Hệ thống phần mềm Sàn giao dịch công nghệ",
    imageUrl: logoSGD,
    type: "Website / Mobile Apps",
    responsibility: ["Mobile Development", "UI/UX Design"],
    credit: "https://dribbble.com/shots/15223131-Freelance-Mobile-App-Concept",
  },
];

export const Advantages = [
  [
    {
      title: "Kinh nghiệm",
      description:
        "Chúng tôi kết hợp sức trẻ, tư duy sáng tạo và đội ngũ chuyên gia giàu kinh nghiệm để mang đến giải pháp tối ưu, đảm bảo chất lượng và giá trị bền vững.",
      imageUrl: Communicative,
    },
    {
      title: "Mở rộng",
      description:
        "Giải pháp linh hoạt, dễ dàng triển khai trên nhiều nền tảng và thiết bị, tối ưu hóa khả năng tích hợp và nâng cao trải nghiệm người dùng.",
      imageUrl: Management,
    },
  ],
  [
    {
      title: "Dịch vụ",
      description:
        "Ứng dụng công nghệ tiên tiến, chúng tôi tạo ra các sản phẩm chất lượng, linh hoạt và sẵn sàng mở rộng, giúp khách hàng luôn dẫn đầu xu hướng.",
      imageUrl: Collaborative,
    },
    {
      title: "Giá cạnh tranh",
      description:
        "Tại Newtech chúng tôi tập trung vào việc mang lại giá trị thặng dư cho khách hàng. Lợi ích mang lại luôn lớn hơn rất nhiều so với giá trị đầu tư của khách hàng.",
      imageUrl: Favorite,
    },
  ],
];
export const Testimonials = [
  {
    id: 1,
    name: "Khách hàng B",
    company: "Trưởng phòng, Viettel",
    testimoni:
      "Các giải pháp và dịch vụ mà NEWTECH cung cấp đã đáp ứng tốt các yêu cầu kỹ thuật và chiến lược của chúng tôi, đồng thời góp phần quan trọng vào việc nâng cao hiệu quả hoạt động của Viettel. Chúng tôi đặc biệt ấn tượng với khả năng linh hoạt và sự nhanh nhạy trong việc giải quyết các vấn đề phát sinh trong quá trình triển khai.",
    imageUrl: ViettelComp,
    imageCompanyUrl: ViettelUser,
  },
  {
    id: 2,
    name: "Khách hàng C",
    company: "Phó giám đốc, Heineken",
    testimoni:
      "Chúng tôi mong muốn tiếp tục duy trì và mở rộng mối quan hệ hợp tác tốt đẹp này với NEWTECH trong thời gian tới, và tin tưởng rằng sự hợp tác giữa hai bên sẽ ngày càng thành công hơn nữa. Chân thành cảm ơn và chúc quý công ty ngày càng phát triển.",
    imageUrl: HeinekenComp,
    imageCompanyUrl: HeinekenUser,
  },
  {
    id: 3,
    name: "Khách hàng A",
    company: "Giám đốc, Eximbank",
    testimoni:
      "Chúng tôi xin chân thành cảm ơn NEWTECH vì sự hợp tác và hỗ trợ quý báu trong thời gian qua. Qua các dự án đã thực hiện, chúng tôi đánh giá cao sự chuyên nghiệp, chất lượng và hiệu quả mà đội ngũ của quý công ty đã mang lại. Chúng tôi đặc biệt ấn tượng với sự sáng tạo và năng lực giải quyết vấn đề của các bạn, cũng như khả năng đáp ứng nhanh chóng các yêu cầu và điều chỉnh trong quá trình triển khai dự án. Sự tận tâm và cam kết của NEWTECH đã góp phần không nhỏ vào thành công của các dự án mà chúng tôi đã thực hiện.",
    imageUrl: EximbankComp,
    imageCompanyUrl: EximbankUser,
  },
];

export const TeamMembers = [
  {
    name: "Rach David",
    position: "CEO",
    imageUrl: CEO,
  },
  {
    name: "Pauline Sydney",
    position: "HRD",
    imageUrl: HRD,
  },
  {
    name: "Granger Watterson",
    position: "Finance",
    imageUrl: Finance,
  },
  {
    name: "Tom Jimmy",
    position: "Project Manager",
    imageUrl: ProjectManager,
  },
  {
    name: "Jim Hendrix",
    position: "Front-end Developer",
    imageUrl: Frontend1,
  },
  {
    name: "Calvin Max",
    position: "Front-end Developer",
    imageUrl: Frontend2,
  },
  {
    name: "Hawkins Jim",
    position: "Back-end Developer",
    imageUrl: Backend1,
  },
  {
    name: "Don Bizaro",
    position: "Back-end Developer",
    imageUrl: Backend2,
  },
  {
    name: "Bill Markinson",
    position: "Mobile Developer",
    imageUrl: Mobile1,
  },
  {
    name: "Igor Kavarov",
    position: "Mobile Developer",
    imageUrl: Mobile2,
  },
  {
    name: "Freddie Curl",
    position: "UI/UX Designer",
    imageUrl: UIUX2,
  },
  {
    name: "Monica Lovegood",
    position: "UI/UX Designer",
    imageUrl: UIUX1,
  },
];
